<script setup lang="ts">
// 일기에 아직 등록 안 된 사람이 포착되면 "추가할까요?"를 보여 준다(규칙 감지 + 사용자 확인).
// 추가하면 부모가 사람을 만들고 조직(관리) 화면으로 데려가 위치를 정하게 한다.
import { useI18n } from 'vue-i18n'
import { icon } from '../lib/icons'

defineProps<{ names: string[] }>()
const emit = defineEmits<{ add: [name: string]; ignore: [] }>()
const { t } = useI18n()
</script>

<template>
  <div v-if="names.length" class="newp" role="region" :aria-label="t('newp.found')">
    <div class="newp-h"><span v-html="icon('plus')"></span>{{ t('newp.found') }}</div>
    <div class="newp-list">
      <button v-for="n in names" :key="n" class="newp-chip" @click="emit('add', n)">
        {{ n }}<em>{{ t('newp.add') }}</em>
      </button>
    </div>
    <button class="newp-ignore" @click="emit('ignore')">{{ t('newp.ignore') }}</button>
  </div>
</template>

<style scoped>
.newp { background: var(--card); border: 1px solid var(--line); border-radius: 16px; padding: 12px 14px; margin: 12px 0;
  box-shadow: var(--shadow); animation: newp-in .35s cubic-bezier(.2,.8,.2,1); }
@keyframes newp-in { from { transform: translateY(8px); opacity: 0; } }
.newp-h { display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 700; color: var(--ink); margin-bottom: 10px; }
.newp-h :deep(.ico) { width: 15px; height: 15px; }
.newp-list { display: flex; flex-wrap: wrap; gap: 8px; }
.newp-chip { display: inline-flex; align-items: center; gap: 8px; border: 1px solid var(--ink); background: var(--ink); color: var(--paper);
  border-radius: 999px; padding: 8px 12px; font: inherit; font-size: 14px; font-weight: 700; cursor: pointer; }
.newp-chip em { font-style: normal; font-weight: 500; font-size: 12px; opacity: .8; }
.newp-ignore { margin-top: 10px; border: 0; background: none; color: var(--pencil); font: inherit; font-size: 13px; cursor: pointer; padding: 4px 2px; }
</style>
